<template>
  <div class="wrapper home">
    <div
      class="suspension"
      @mouseover="suspensionMouseOver"
      @mouseleave="suspensionMouseLeave"
      v-if="isSuspension&&suspensionContent.length"
    >
      <a
        :href="suspensionContent[0].linkUrl"
        target="_blank"
        v-if="suspensionContent.length > 0"
      >
        <img
          :src="$store.store.state.windonsrc + suspensionContent[0].imgBase64"
          style="width: 100%; height: 100%"
        />
      </a>
      <div class="suspension_close" @click="isSuspension = false">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- <div class="wrapper block">
      <el-carousel trigger="click" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <a :href="item.linkUrl" target="_blank" v-if="item.linkUrl">
            <img
              ref="bannerHeight"
              :src="$store.store.state.windonsrc + item.imgBase64"
              style="width: 100%; height: 260px"
              @load="imgLoad"
            />
          </a>
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="wrapper home_content">
      <NewHome></NewHome>
    </div>
  </div>
</template>

<script>
import {
  getmenu,
  bannerQuery,
  linkQuery,
  handleGuide,
  meetingnotice,
} from "@/request/api";
import Header from "@/components/header.vue";
import NewHome from "@/view/newHome.vue";
import img from "./center/img.vue";
export default {
  components: { img,NewHome,Header },
  name: "HelloWorld",
  data() {
    return {
      activeNameNotice: 0,
      bannerList: [], //banner图
      newsList: [
        { menuName: "通知公告", id: "5_1", newsContent: [], totalCountVal: "" },
        { menuName: "新闻动态", id: "3_1", newsContent: [], totalCountVal: "" },
        { menuName: "政策法规", id: "4_1", newsContent: [], totalCountVal: "" },
      ], //新闻资讯tab列表
      policyList: [], //政策法规列表
      policyContent: [], //政策法规列表-内容
      policyIndex: 0,
      clinicalCenter: "", //中心介绍-临床试验中心
      relatedLinksList: [], //相关链接
      educationList: [], //教育培训
      suspensionContent: "",
      isSuspension: true,
      timer: "",
      sxVal: 0,
      syVal: 0,
      bannerHeight: "",
    };
  },
  created() {
    this.bannerQuery_Fun(1, "1_1"); //banner图
    this.bannerQuery_Fun(2, "1_2"); //专委会介绍
    this.getmenu_Fun(4); //政策法规
    this.linkQuery_Fun("11_1", 1); //链接管理-相关链接
    this.handleGuide_Fun(5, "5_1", 5, 0); //学术活动
    this.handleGuide_Fun(8, "8_1", 4, "-1"); //教育培训
    this.linkQuery_Fun("12_1", 2); //悬浮窗
    this.suspension();
  },
  mounted() {
    this.$nextTick(() => {
      //元素加载完成后执行的代码
      setTimeout(() => {
        this.suspension();
      }, 500);
    });
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
        console.log(
          "this.$refs.bannerHeight[0].height",
          this.$refs.bannerHeight[0].height
        );
      });
    },
    goMore(index) {
      console.log(index);
      if (index == 0) {
        this.$router.push({
          path: "/learn",
        });
      } else if (index == 1) {
        this.$router.push({
          path: "/meeting",
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/welfare",
        });
      }
    },

    getmenu_Fun(parentMenuId) {
      let params = {
        parentMenuId: parentMenuId,
        pageSize: 100,
        pageNumber: 1,
      };
      getmenu(params)
        .then((res) => {
          console.log(res);
          console.log(parentMenuId);
          if (res.data.code == 200) {
            if (parentMenuId == 4) {
              //政策法规
              this.policyList = res.data.data.list;
              this.handleGuide_Fun(4, res.data.data.list[0].id, 6, 0);
              console.log(this.policyList);
            }
          }
        })
        .catch((err) => {});
    },
    bannerQuery_Fun(type, blongToMenu) {
      let params = {};
      if (type == 1) {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 10,
          pageNumber: 1,
          type: type,
        };
      } else {
        params = {
          blongToMenu: blongToMenu,
          pageSize: 1,
          pageNumber: 1,
        };
      }
      bannerQuery(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (type == 1) {
              this.bannerList = res.data.data.list;
            } else if (type == 2) {
              this.clinicalCenter = res.data.data.list[0];
            }
          }
        })
        .catch((err) => {});
    },
    linkQuery_Fun(blongToMenu, type) {
      // 相关链接
      let params = {
        blongToMenu: blongToMenu,
        pageSize: 100,
        pageNumber: 1,
        type: type,
      };
      linkQuery(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (type == 1) {
              // 相关链接
              this.relatedLinksList = res.data.data.list;
            } else if (type == 2) {
              this.suspensionContent = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },

    noticeClick(tab, event) {
      console.log(tab, event);
      if (tab.index == 0) {
        this.handleGuide_Fun(5, this.newsList[tab.index].id, 5, tab.index);
      } else if (tab.index == 1) {
        this.handleGuide_Fun(6, this.newsList[tab.index].id, 5, tab.index);
      } else {
        this.handleGuide_Fun(7, this.newsList[tab.index].id, 5, tab.index);
      }
    },
    meetingnotice_Fun(num, blongToMenu, pageSize, index) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: pageSize,
        pageNumber: 1,
      };
      meetingnotice(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.newsList[index].newsContent = res.data.data.list;
            this.newsList[index].totalCountVal = res.data.data.totalCount;
            // this.$set(this.newsList, index, this.newsList[index]);
          }
        })
        .catch((err) => {});
    },
    policyClick(index) {
      this.policyIndex = index;
      console.log(this.policyList[index].id);
      this.handleGuide_Fun(4, this.policyList[index].id, 6, index);
    },
    handleGuide_Fun(num, blongToMenu, pageSize, index) {
      let params = {
        blongToMenu: blongToMenu,
        pageSize: pageSize,
        pageNumber: 1,
      };
      handleGuide(params)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            if (num == 5 || num == 6 || num == 7) {
              this.newsList[index].newsContent = res.data.data.list;
              this.newsList[index].totalCountVal = res.data.data.totalCount;
              // this.$set(this.newsList, index, this.newsList[index]);
            } else if (num == 8) {
              this.educationList = res.data.data.list;
            } else if (num == 4) {
              this.policyContent = res.data.data.list;
            }
          }
        })
        .catch((err) => {});
    },
    lookMore(url) {
      this.$router.push({ path: url });
    },
    suspension() {
      var obj = document.getElementsByClassName("suspension");
      console.log(obj);
      console.log(obj.css);
      console.log(obj[0]);
      var x = obj[0].offsetLeft; //盒子距离左部的位置
      var y = obj[0].offsetTop; //盒子距离顶部的位置
      console.log(x);
      console.log(y);

      var objwid = obj[0].scrollWidth; //盒子的宽
      var objhei = obj[0].scrollHeight;
      console.log(objwid);
      console.log(objhei);

      var winwid = document.documentElement.clientWidth; //页面的宽
      var winhei = document.documentElement.clientHeight;

      console.log(winwid);
      console.log(winhei);

      // var max = 10; //设置最大视觉差，就是感觉这个距离刚好碰到
      var winx = winwid - objwid; //盒子x轴最远达到的距离
      var winy = winhei - objhei; //盒子y轴最远达到的距离

      var sx = this.sxVal; //x轴是否返回的状态，0是值++即正向移动，1是值--即返回
      var sy = this.syVal;
      console.log(this.sxVal);
      console.log(this.syVal);
      console.log(sx);
      console.log(sy);
      console.log(obj[0].offsetLeft);
      window.clearInterval(this.timer);
      let _this = this;
      this.timer = setInterval(function () {
        if (sx == 0) {
          x++;
          obj[0].style.left = x + "px";
        } else if (sx == 1) {
          x--;
          obj[0].style.left = x + "px";
        }
        if (x <= 0) {
          sx = 0;
          _this.sxVal = 0;
        } else if (x >= winx) {
          sx = 1;
          _this.sxVal = 1;
        }

        if (sy == 0) {
          y++;
          obj[0].style.top = y + "px";
        } else if (sy == 1) {
          y--;
          obj[0].style.top = y + "px";
        }
        if (y <= 0) {
          sy = 0;
          _this.syVal = 0;
        } else if (y >= winy) {
          sy = 1;
          _this.syVal = 1;
        }
      }, 20);
    },
    suspensionMouseOver() {
      window.clearInterval(this.timer);
    },
    suspensionMouseLeave() {
      this.suspension();
    },
  },
  beforeDestroy() {
    console.log(55555555555);
    window.clearInterval(this.timer);
  },
};
</script>

<style>
.home_notice .el-tabs__header {
  position: absolute;
  top: -90px;
  left: 0;
}
.home_notice .el-tabs__nav-wrap::after {
  background-color: transparent;
}
.home_notice .el-tabs__active-bar {
  background-color: #018277;
  width: 124px;
}
.home_notice .el-tabs__item.is-active,
.home_notice .el-tabs__item:hover {
  color: #018277;
}
.home_notice .el-tabs__item.is-active {
  font-size: 26px;
  font-weight: bold;
}
.home_notice .el-tabs__item {
  font-size: 16px;
}
.tipsclass {
  margin-left: -100px !important;
}
</style>
<style scoped>
.home_content {
  margin-top: 50px;
}
.home_title2 {
  height: 40px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}
.home_title2_name {
  font-size: 26px;
  color: #1a1a1a;
}
.home_title2_btn {
  width: 280px;
  height: 50px;
  background: url(../../static/images/home/titleBtn.png) no-repeat;
  background-size: cover;
  padding-left: 22px;
  align-items: center;
  color: #fff;
  line-height: 50px;
}
.home_notice {
  position: relative;
}
.home_notice_content {
  min-height: 444px;
  justify-content: flex-end;
  position: relative;
  flex-wrap: wrap;
}
.home_notice_content_mian {
  flex-direction: column;
}
.home_notice_content_info {
  width: 610px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.home_notice_content1 {
  width: 490px;
  position: absolute;
  top: 0;
  left: 0;
}
.home_notice_content2 {
  width: 290px;
}
.home_notice_content3 {
  width: 610px;
}
.home_notice_ {
  cursor: pointer;
}
.home_notice_:nth-child(4) {
  border-top: 1px solid #cccccc;
  margin-top: 35px;
}
.home_notice_:last-child {
  margin-bottom: 10px;
}
.home_notice_left {
  width: 490px;
}
.home_notice_img {
  width: 100%;
  height: 300px;
  position: relative;
}
.home_notice_date1 {
  padding: 15px 20px;
  background-color: #018277;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}
.home_notice_date2 {
  padding: 8px 20px;
  background-color: #018277;
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
}
.home_notice_left_text {
  width: 100%;
  height: 90px;
  background-color: #f8f8f8;
  padding: 0 22px;
  line-height: 30px;
  font-size: 16px;
  color: #4d4d4d;
  align-items: center;
}
.home_notice_left_content {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 25px;
}
.home_notice_right {
  width: 610px;
  height: auto;
}
.home_notice_show_in {
  width: 290px;
  height: auto;
}
.home_notice_show_img {
  width: 100%;
  height: 178px;
  position: relative;
}
.home_notice_show_title {
  width: 100%;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #4d4d4d;
  margin-top: 30px;
}
.home_notice_list_in {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #cccccc;
  align-items: center;
  justify-content: space-between;
}
.home_notice_list_title {
  width: 480px;
  font-size: 14px;
  color: #4d4d4d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_notice_list_date {
  font-size: 14px;
  color: #4d4d4d;
}
.home_title1 {
  width: 100%;
  height: 140px;
  align-content: center;
  flex-wrap: wrap;
}
.home_title1.home_title1_wrapper {
  height: 200px;
  padding-bottom: 60px;
  background: url(../../static/images/home/educationTrainingBg.png) no-repeat;
  background-size: cover;
}
.home_title1_name {
  width: 100%;
  font-size: 26px;
  color: #1a1a1a;
  text-align: center;
}
.home_title1_border {
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
  justify-content: center;
  margin: 10px 0;
}
.home_title1_border_in {
  width: 56px;
  height: 1px;
  background-color: #018277;
}
.home_title1_English {
  width: 100%;
  font-size: 14px;
  color: #1a1a1a;
  text-align: center;
}
.home_title1_wrapper .home_title1_name,
.home_title1_wrapper .home_title1_English {
  color: #fff;
}
.home_title1_wrapper .home_title1_border {
  background-color: transparent;
}
.home_title1_wrapper .home_title1_border_in {
  background-color: #fff;
}
.home_center {
  justify-content: space-between;
}
.home_center_img {
  height: 250px;
}
.home_center_info {
  width: 650px;
  height: 250px;
}
.home_center_synopsis {
  height: 202px;
  overflow: hidden;
}
.home_education {
  padding-top: 290px;
  position: relative;
}
.home_education_photo1 {
  width: 100%;
  height: 290px;
  position: absolute;
  top: 0;
  left: 0;
}
.home_education_photo2 {
  width: 360px;
  height: 240px;
  position: relative;
  margin-right: 62px;
}
.home_education_photo2:last-child {
  margin-right: 0;
}
.home_education_first {
  width: 100%;
  height: 290px;
  background-color: #fff;
  box-shadow: 0px 2px 18px 0px rgba(126, 126, 126, 0.24);
  margin-top: -60px;
  padding: 33px 50px 33px 70px;
  justify-content: space-between;
}
.home_education_img {
  width: 360px;
  height: 226px;
  position: relative;
}
.home_education_info {
  width: 675px;
  padding-top: 10px;
  align-content: space-between;
  flex-wrap: wrap;
}
.home_education_title {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #4c4c4c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
}
.home_education_synopsis {
  font-size: 12px;
  line-height: 28px;
  color: #4c4c4c;
  margin-top: 15px;
}
.home_education_btn {
  width: 100px;
  height: 28px;
  background-color: #5bafbc;
  border-radius: 2px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  font-size: 14px;
  margin-top: 30px;
  cursor: pointer;
}
.home_education_photo_in {
  width: 360px;
  height: 240px;
  position: relative;
  cursor: pointer;
}
.home_education_photo_title {
  width: 360px;
  height: 44px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: url(../../static/images/common/bg.png);
  text-align: center;
  padding: 0 10px;
  line-height: 44px;
  color: #fff;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_education_photo_in:hover .home_education_photo_title {
  background: url(../../static/images/common/bg1.png);
}
.home_regulations_nav {
  height: 50px;
  background-color: #018277;
}
.home_regulations_nav_in {
  width: 33.33%;
  height: 50px;
  position: relative;
  cursor: pointer;
}
.home_regulations_nav_num {
  width: 50px;
  height: 50px;
  background-color: #027268;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 16px;
  position: absolute;
  top: 0;
  left: 0;
}
.home_regulations_nav_title {
  line-height: 50px;
  color: #fff;
  font-size: 16px;
  margin-left: 70px;
}
.home_regulations_nav_hot .home_regulations_nav_num {
  height: 73px;
  background-color: #09a799;
  font-weight: bold;
  font-size: 20px;
  line-height: 73px;
}
.home_regulations_nav_hot .home_regulations_nav_title {
  font-weight: bold;
}
.home_regulations {
  flex-wrap: wrap;
  margin-top: 60px;
  padding-bottom: 75px;
}
.home_regulations_in {
  border-right: 1px solid #cccccc;
  padding-top: 45px;
  cursor: pointer;
}
.home_regulations_in:nth-child(1),
.home_regulations_in:nth-child(2),
.home_regulations_in:nth-child(3) {
  border-bottom: 1px solid #cccccc;
  padding-top: 0;
  padding-bottom: 45px;
}
.home_regulations_in:nth-child(1),
.home_regulations_in:nth-child(4) {
  width: 382px;
  padding-right: 45px;
}
.home_regulations_in:nth-child(2),
.home_regulations_in:nth-child(5) {
  width: 435px;
  padding-left: 45px;
  padding-right: 45px;
}
.home_regulations_in:nth-child(3),
.home_regulations_in:nth-child(6) {
  width: 383px;
  padding-left: 45px;
  border-right: none;
}
.home_regulations_title {
  width: 100%;
  height: 20px;
  font-size: 16px;
  color: #1a1a1a;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_regulations_in:hover .home_regulations_title {
  color: #018277;
}
.home_regulations_date {
  font-size: 12px;
  color: #333;
  margin: 20px 0 15px;
}
.home_regulations_synopsis {
  font-size: 12px;
  color: #999;
  line-height: 20px;
}
.home_link {
  background-color: #fafafa;
  padding-bottom: 70px;
}
.home_link_info {
  flex-wrap: wrap;
}
.home_link_in {
  display: block;
  width: 250px;
  height: 40px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px rgba(126, 126, 126, 0.17);
  padding: 0 5px;
  margin-right: 45px;
  margin-bottom: 12px;
  align-items: center;
  cursor: pointer;
  color: #4d4d4d;
  font-size: 14px;
  padding: 0 5px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.home_link_in:nth-child(4n) {
  margin-right: 0;
}
.home_link_in:hover {
  color: #018277;
}
.home_synopsis_more {
  height: 28px;
  background-color: #018277;
  border-radius: 100px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  line-height: 28px;
  align-items: center;
  color: #fff;
  cursor: pointer;
  margin-top: 20px;
}
.home_synopsis_more i {
  font-size: 20px;
}
.home_synopsis_more span {
  margin-left: 8px;
}
.suspension {
  width: 200px;
  height: 80px;
  position: fixed;
  top: 220px;
  left: 137px;
  z-index: 10;
  cursor: pointer;
}
.suspension a {
  display: block;
  width: 200px;
  height: 112px;
}
.suspension_close {
  width: 25px;
  height: 25px;
  font-size: 16px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  background: url(../../static/images/common/bg.png);
  text-align: center;
  line-height: 25px;
}
.home_notice_date3 {
  padding: 2px 5px;
  background-color: #018277;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue